export const EXTRA_KEY_FOB = [
  {
    key: "Hardware",
    value: "hardwareTitle",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "80px",
  },
  //   {
  //     key: "Hardware Status",
  //     value: "status",
  //     isFilterEnabled: false,
  //     isCustomFilter: false,
  //     isSortable: false,
  //     isHyperLink: false,
  //     ellipsis: false,
  //     width: "100px",
  //   },
  {
    key: "Category",
    value: "type",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "80px",
  },
  {
    key: "Sub-Category",
    value: "subType",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "130px",
  },
  {
    key: "Subscription Name",
    value: "subscriptionName",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "220px",
  },
  {
    key: "Subscription ID",
    value: "subscriptionId",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "150px",
  },
  {
    key: "Tech Ref Id",
    value: "techRefId",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "200px",
  },
  {
    key: "Hardware Name",
    value: "hardwareName",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "200px",
  },
  {
    key: "Hardware Id",
    value: "hardwareId",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "100px",
  },
  {
    key: "Quantity",
    value: "quantity",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "80px",
  },
];
